import { MobileIssueDtoArtifactFragment, MobileIssueSectionContainer } from 'data/generated/graphql';
import { CollectionNode } from 'hooks/useAllessehCollectionSummariesQuery';

export const insertIssueNodeAtIndex = (
  issue: MobileIssueDtoArtifactFragment,
  index: number,
  sectionData: MobileIssueSectionContainer
): MobileIssueDtoArtifactFragment => {
  const clone = structuredClone(issue);
  const rootCollection = clone.root.collection;
  const updatedRoot = [...rootCollection];
  updatedRoot.splice(index + 1, 0, sectionData);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  clone.root.collection = updatedRoot as any;
  return clone;
};

export const deleteIssueNodeAtIndex = (
  issue: MobileIssueDtoArtifactFragment,
  index: number
): MobileIssueDtoArtifactFragment => {
  const clone = structuredClone(issue);
  const rootCollection = clone.root.collection;

  const updatedCollection = [...rootCollection];
  updatedCollection.splice(index, 1);

  clone.root.collection = updatedCollection;
  return clone;
};

export const getParam = (node: CollectionNode, name: string): string | undefined =>
  node.parameters?.find((p) => p.name === name)?.value;

export interface MobileIssueSectionSummary {
  id: string;
  sectionLabel?: string | null;
}
